import NiceModal from "@ebay/nice-modal-react";
import FlexChild from "layouts/flex/FlexChild";
import ModalBase from "modals/base/ModalBase";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { createRef, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import style from "./VariantStatusModal.module.css";
import { adminRequester, requester } from "App";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "components/buttons/CustomButton";
import clsx from "classnames";
import TabView from "layouts/view/TabView";
import TabViewChild from "layouts/view/TabViewChild";
import InputText from "components/inputs/InputText";
import CheckCircleGroup from "components/inputs/checkBox/CheckCircleGroup";
import ProductOptionRow from "./ProductOptionRow";
import CheckCircle from "components/inputs/checkBox/CheckCircle";
import { Container } from "@mui/material";
import Dummy from "components/Dummy";
import RadioChildren from "components/manager/views/forms/radio/RadioChildren";
import RadioGroup from "components/manager/views/forms/radio/RadioGroup";
import { textFormat } from "InitialData/regExp";
import InputNumber from "components/inputs/InputNumber";
import InputHashTag from "components/inputs/InputHashTag";
import QuillEditor from "components/inputs/richEditor/QuillEditor";
import AdminInputImage from "components/inputs/image/AdminInputImage";
import { validateInputs } from "shared/utils/Utils";
import { CButton, CSpinner } from "@coreui/react";
import AdminImageBlock from "components/inputs/image/AdminImageBlock";
import FlexGrid from "layouts/flex/FlexGrid";
import AdminQuillEditor from "components/inputs/richEditor/AdminQuillEditor";
import { useNavigate } from "react-router-dom";

const VariantStatusModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  const { isMobile } = useContext(BrowserDetectContext);
  const { data, onSuccess } = props;
  const inputs = useRef([]);
  const [withHeader, withFooter] = [true, false];
  const [width, height] = ["min(95%, 1200px)", "80vh"];
  const withCloseButton = true;
  const clickOutsideToClose = true;
  const modal = useRef();
  const title = "상품 정보";
  const buttonText = t("close");
  const [displayYn, setDisplayYn] = useState();
  const [saleYn, setSaleYn] = useState();
  const [limitNum, setLimitNum] = useState(0);
  const [pointNum, setPointNum] = useState(0);
  const [categories, setCategories] = useState([]);
  //   const [selectedCategory, setSelectedCategory] = useState([]);
  const [options, setOptions] = useState([]);
  const [optionValues, setOptionValues] = useState([]);
  const [optionValuesIds, setOptionValuesIds] = useState({});
  const [selected, setSelect] = useState([]);
  const [isMounted, setMounted] = useState(false);
  const [product, setProduct] = useState();
  const [isOpenCustomerPrice, setOpenCustomerPrice] = useState(false);
  const [user, setUser] = useState();
  const [isSpin, setSpin] = useState(false);
  const [origin, setOrigin] = useState([]);
  // min(95%, 1200px)
  useEffect(() => {
    setMounted(true);
  }, [isMounted]);
  useEffect(() => {
    if (isMounted) {
      adminRequester.getCategories(
        { include_descendants_tree: true },
        (result) => setOrigin(result.product_categories.flat())
      );
      adminRequester.getCurrentUser((result) => setUser(result.user));
    }
  }, [isMounted]);
  useEffect(() => {
    if (data && origin) {
      setDisplayYn(data.product.status === "published" ? true : false);
      setSaleYn(data.product.buyable);
      setCategories(
        data.product.categories?.map((category) => findParent(category))
      );
      //   data.product.options.map((option) => {
      //     optionValuesIds[option.title] = option.id;
      //     return option.title;
      //   })
      const optionValuesIds = data.product.options.reduce(
        (pre, option) => {
          pre.ids[option.title] = option.id;
          pre.values.push(option.title);
          return pre;
        },
        { values: [], ids: {} }
      );
      setOptionValues(optionValuesIds?.values);
      setOptionValuesIds(optionValuesIds?.ids);
      setOptions(
        data.product.variants.map((variant) => {
          //   const options = variant.options.map((option) => {
          //     const data = {};
          //     data[option.option.title] = option.value;
          //     return data;
          //   });
          const options = variant.options.reduce((pre, option) => {
            pre[option.option.title] = option.value;
            return pre;
          }, {});
          return {
            id: variant.id,
            title: variant.title,
            price:
              Number(variant.price || 0) - Number(data.product?.price || 0),
            quantity: variant.inventory_quantity,
            check: variant.check,
            sold: variant.sold,
            ...options,
            thumbnail: variant.thumbnail,
          };
        })
      );
    }
  }, [data, origin]);
  const findParent = (pre) => {
    const category = { ...pre };
    if (category?.parent_category_id != null) {
      const parent_category = origin.filter(
        (o) => o.id === category.parent_category_id
      )?.[0];
      category.parent_category =
        parent_category?.parent_category_id == null
          ? parent_category
          : findParent(parent_category);
    }
    return category;
  };
  const onDeleteClick = (idx) => {
    setOptions([...options.filter((opttion, index) => index !== idx)]);
  };
  const onSelectDeleteClick = () => {
    if (selected?.length === 0) setOptions([]);
    else
      setOptions([
        ...options.filter((opttion, index) => !selected.includes(index)),
      ]);
    setSelect([]);
  };
  const onSelectDuplicateClick = () => {
    const copies = options
      .filter((opttion, index) => selected.includes(index))
      .map((option) => {
        const copy = { ...option };
        delete copy.id;
        return copy;
      });
    setOptions([...options, ...copies]);
    setSelect([]);
  };
  const getName = (category) => {
    return category.parent_category != null
      ? `${getName(category.parent_category)} > ${category.name}`
      : category.name;
  };
  const onCategoryRegisterClick = () => {
    NiceModal.show("categoryRegister", { onChange: categoryRegCallback });
  };

  const categoryRegCallback = ({ value }) => {
    setCategories([...new Set([...categories, value])]);
    // requester.getAllCategoriesForAdmin((result) => {
    //   setCategories(result.data);
    // });
  };
  const onOptionRegisterClick = () => {
    NiceModal.show("optionRegister", {
      onChange: optionRegCallback,
      options:
        options.length === 0
          ? [{ title: null, price: 0, qauntity: 0, check: 0, sold: false }]
          : options,
      optionValues: optionValues,
    });
  };
  const optionRegCallback = (options, optionValues) => {
    setOptions(options);
    setOptionValues(optionValues);
  };

  const onSaveClick = () => {
    if (optionValues.length === 0 || options.length === 0) {
      toast.error("옵션은 최소 1개가 필요합니다.", {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else {
      let product = {};
      inputs.current[6].isValid().then(() => {
        product.thumbnail = inputs.current[6].getValue();
        product.title = inputs.current[0].getValue();
        product.handle = new Date().getTime() + "_" + product.title;
        product.description = inputs.current[1].getValue();
        product.status = displayYn ? "published" : "rejected";
        product.categories = categories?.map((category) => ({
          id: category.id,
        }));
        product.store_id = user?.store_id;
        product.price = inputs.current[2].getValue();
        product.customer_price = isOpenCustomerPrice
          ? inputs.current[3].getValue()
          : null;
        product.buyable = saleYn;
        inputs.current[7].isValid().then(() => {
          product.content = inputs.current[7].getValue();
          adminRequester.updateProduct(
            data.product.id,
            { ...product },
            (result) => {
              const { product } = result;
              Promise.all(
                optionValues.map((ov) => {
                  if (!(ov in optionValuesIds)) {
                    // 신규
                    return adminRequester.postProductOption(
                      product?.id,
                      { title: ov },
                      () => {}
                    );
                  }
                  return ov;
                })
              ).then(() => {
                Promise.all(
                  data.product.options.map((option) => {
                    
                    // if (!(option.title in optionValues)) {
                    //   // 삭제
                    //   return adminRequester.deleteProductOption(
                    //     product?.id,
                    //     option.id,
                    //     { force: true },
                    //     () => {}
                    //   );
                    // }
                    return option;
                  })
                ).then(() => {
                  adminRequester.getProduct(
                    product?.id,
                    { expand: "options,variants" },
                    (result) => {
                      const { product } = result;
                      Promise.all(
                        product?.variants.map((variant) => {
                          if (
                            !options.some((option) => option?.id === variant.id)
                          ) {
                            // 삭제
                            return adminRequester.deleteVariant(
                              product.id,
                              variant.id,
                              () => {}
                            );
                          }
                          return variant;
                        })
                      ).then(() => {
                        Promise.all(
                          options.map((option) => {
                            return option.input.isValid().then(() => {
                              const data = {};

                              data.thumbnail = option.input.getValue();
                              data.title = option.title;
                              data.inventory_quantity = option.qauntity;
                              data.check = option.check;
                              data.sold = option.sold;
                              const prices = [
                                {
                                  amount:
                                    Number(product?.price || 0) +
                                    Number(option?.price || 0),
                                  currency_code: "krw",
                                },
                              ];
                              data.options = product.options.map((op) => ({
                                option_id: op.id,
                                value: option[op.title],
                              }));
                              if (option.id) {
                                // 업데이트
                                return adminRequester.updateVariant(
                                  product?.id,
                                  option.id,
                                  { ...data, prices: prices },
                                  () => {}
                                );
                              } else {
                                // 신설
                                return adminRequester.postVariants(
                                  product?.id,
                                  data,
                                  (result) => {
                                    adminRequester.updateVariant(
                                      product?.id,
                                      result.variant.id,
                                      { prices: prices },
                                      () => {}
                                    );
                                  }
                                );
                              }
                            });
                          })
                        ).then((r) => {
                          modal.current.close();
                          onSuccess?.(r);
                        });
                      });
                    }
                  );
                });
              });
            }
          );
        });
      });
      setSpin(true);
    }
  };

  const Button = ({ text, onClick }) => {
    const btnStyle = {
      backgroundColor: "white",
      color: "#727272",
      borderColor: "#727272",
      borderRadius: "5px",
      padding: "3px 10px",
      fontSize: "10pt",
    };
    return (
      <CButton
        style={btnStyle}
        color={"primary"}
        onClick={onClick}
        active={true}
      >
        {text}
      </CButton>
    );
  };

  return (
    <ModalBase
      borderRadius={"10px"}
      headerStyle
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
    >
      <div style={{ overflow: "scroll", height: "75vh" }}>
        <Container maxWidth={1500}>
          <VerticalFlex gap={20}>
            <FlexChild>
              <div className={style.container} sty>
                <VerticalFlex>
                  <FlexChild>
                    <div className={style.contentWrap}>
                      <VerticalFlex gap={20}>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>카테고리 설정</P>
                            </FlexChild>
                            <FlexChild>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "15px",
                                  flexWrap: "wrap",
                                }}
                              >
                                {categories?.length === 0 && (
                                  <P>선택된 카테고리가 없습니다.</P>
                                )}
                                {categories &&
                                  categories?.map((category, index) => (
                                    <FlexChild key={index} width={"initial"}>
                                      <div
                                        className={style.categoryWrap}
                                        onClick={() =>
                                          setCategories([
                                            ...categories?.filter(
                                              (filter) =>
                                                filter.id !== category.id
                                            ),
                                          ])
                                        }
                                      >
                                        <Center
                                          width={"100%"}
                                          textAlign={"left"}
                                        >
                                          <P>{getName(category)}</P>
                                        </Center>
                                      </div>
                                    </FlexChild>
                                  ))}
                              </div>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"} />
                            <FlexChild>
                              <div
                                className={style.categoryModalBtn}
                                onClick={onCategoryRegisterClick}
                              >
                                <P>카테고리 등록</P>
                              </div>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <div className={style.line} />
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>상품명</P>
                            </FlexChild>
                            <FlexChild>
                              <InputText
                                value={data && data.product.title}
                                ref={(el) => (inputs.current[0] = el)}
                                name={"상품명"}
                                placeHolder={"상품명을 입력하세요."}
                                regExp={[textFormat]}
                              />
                            </FlexChild>
                            {/* <FlexChild width={"30%"}>
                              <InputText placeHolder={"상품번호 자동 생성"} disabled />
                            </FlexChild> */}
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>요약설명</P>
                            </FlexChild>
                            <FlexChild>
                              <InputText
                                value={data && data.product.description}
                                placeHolder={
                                  "상품명 밑에 보여지는 문구 입니다."
                                }
                                ref={(el) => (inputs.current[1] = el)}
                                name={"요약설명"}
                              />
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex
                            gap={40}
                            justifyContent={"flex-start"}
                          >
                            <FlexChild width={"15%"}>
                              <P>판매가</P>
                            </FlexChild>
                            <FlexChild width={200}>
                              <InputNumber
                                value={data && data.product.price}
                                ref={(el) => (inputs.current[2] = el)}
                                name={"판매가"}
                                min={0}
                                max={999999}
                                required={true}
                                width={200}
                                height={50}
                              />
                            </FlexChild>
                            <FlexChild width={200}>
                              <input
                                type="checkbox"
                                style={{ display: "block", margin: 5 }}
                                onChange={(e) =>
                                  setOpenCustomerPrice(e.target.checked)
                                }
                              />
                              <P>소비자가 설정</P>
                            </FlexChild>
                            <FlexChild width={200}>
                              <InputNumber
                                ref={(el) => (inputs.current[3] = el)}
                                name={"소비자가"}
                                min={0}
                                max={999999}
                                width={200}
                                height={50}
                                disabled={!isOpenCustomerPrice}
                              />
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <div className={style.line} />
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>표시상태</P>
                            </FlexChild>
                            <HorizontalFlex gap={80}>
                              <FlexChild>
                                <FlexChild width={"40%"}>
                                  <P>진열상태</P>
                                </FlexChild>
                                {/* <div className={style.radioWrap}> */}
                                <RadioGroup
                                  name="display"
                                  value={displayYn}
                                  onChange={setDisplayYn}
                                >
                                  <RadioChildren value={true}>
                                    진열
                                  </RadioChildren>
                                  <RadioChildren value={false}>
                                    미진열
                                  </RadioChildren>
                                </RadioGroup>
                                {/* </div> */}
                              </FlexChild>
                              <FlexChild>
                                <FlexChild width={"40%"}>
                                  <P>판매상태</P>
                                </FlexChild>
                                {/* <div className={style.radioWrap}> */}
                                <RadioGroup
                                  name="sales"
                                  value={saleYn}
                                  onChange={setSaleYn}
                                >
                                  <RadioChildren value={true}>
                                    판매
                                  </RadioChildren>
                                  <RadioChildren value={false}>
                                    미판매
                                  </RadioChildren>
                                </RadioGroup>
                                {/* </div> */}
                              </FlexChild>
                            </HorizontalFlex>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex
                            gap={40}
                            justifyContent={"flex-start"}
                          >
                            <FlexChild width={"15%"}>
                              <P>구매제한</P>
                            </FlexChild>
                            <RadioGroup
                              name="limit"
                              value={limitNum}
                              onChange={setLimitNum}
                            >
                              <RadioChildren value={0}>기본 설정</RadioChildren>
                              <RadioChildren value={1}>모두구매</RadioChildren>
                              <RadioChildren value={2}>
                                회원만 구매
                              </RadioChildren>
                            </RadioGroup>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <HorizontalFlex
                            gap={40}
                            justifyContent={"flex-start"}
                          >
                            <FlexChild width={"15%"}>
                              <P>적립금</P>
                            </FlexChild>
                            <RadioGroup
                              name="point"
                              value={pointNum}
                              onChange={setPointNum}
                            >
                              <RadioChildren value={0}>기본 설정</RadioChildren>
                              <RadioChildren value={1}>개별 설정</RadioChildren>
                            </RadioGroup>
                          </HorizontalFlex>
                        </FlexChild>
                      </VerticalFlex>
                    </div>
                  </FlexChild>
                </VerticalFlex>
              </div>
            </FlexChild>
            <FlexChild>
              <div className={style.line} />
            </FlexChild>
            <FlexChild>
              <div className={style.contentWrap}>
                <VerticalFlex gap={20}>
                  <FlexChild>
                    <HorizontalFlex gap={40}>
                      <FlexChild justifyContent="flex-start">
                        <div
                          className={style.categoryModalBtn}
                          onClick={onOptionRegisterClick}
                        >
                          <P>옵션 설정</P>
                        </div>
                      </FlexChild>
                    </HorizontalFlex>
                  </FlexChild>
                  <FlexChild>
                    <FlexGrid columns={2}>
                      {options.length === 0 ? (
                        <div>생성된 옵션이 없습니다.</div>
                      ) : (
                        <></>
                      )}
                      {options?.map((option, index) => (
                        <VerticalFlex key={option.title + "_" + index}>
                          <HorizontalFlex>
                            <FlexChild width="50px">
                              <input
                                type="checkbox"
                                style={{ display: "block", margin: 5 }}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelect([...selected, index]);
                                  } else {
                                    setSelect([
                                      ...selected.filter(
                                        (idx) => index !== idx
                                      ),
                                    ]);
                                  }
                                }}
                                checked={selected.includes(index)}
                              />
                            </FlexChild>
                            <HorizontalFlex>
                              <FlexChild>
                                <P>{option.title}</P>
                              </FlexChild>
                              <FlexChild>
                                <button onClick={() => onDeleteClick(index)}>
                                  X
                                </button>
                              </FlexChild>
                            </HorizontalFlex>
                          </HorizontalFlex>
                          <FlexChild flexStart>
                            <FlexChild>
                              {optionValues
                                ?.map((value) => option[value])
                                .join(",")}
                            </FlexChild>
                          </FlexChild>

                          <FlexChild>
                            <AdminImageBlock
                              ref={(el) => (option.input = el)}
                              name={"상품 라벨"}
                              path={"/product"}
                              labelWidth={0}
                              cropWidth={600}
                              cropHeight={600}
                              value={
                                option && option.thumbnail
                                  ? option.thumbnail
                                  : ""
                              }
                              maxSizeMb={1}
                            />
                          </FlexChild>
                        </VerticalFlex>
                      ))}
                    </FlexGrid>
                  </FlexChild>
                  <FlexChild>
                    <HorizontalFlex gap={40}>
                      <FlexChild gap={40} justifyContent="center">
                        <div
                          className={style.categoryModalBtn}
                          onClick={onSelectDeleteClick}
                        >
                          <P>
                            {selected?.length === 0 ? "일괄삭제" : "선택삭제"}
                          </P>
                        </div>
                        <div
                          className={style.categoryModalBtn}
                          onClick={onSelectDuplicateClick}
                        >
                          <P>옵션복사</P>
                        </div>
                      </FlexChild>
                    </HorizontalFlex>
                  </FlexChild>
                </VerticalFlex>
              </div>
            </FlexChild>
            <FlexChild>
              <div className={style.line} />
            </FlexChild>
            <FlexChild>
              <div className={style.container}>
                <VerticalFlex>
                  <FlexChild>
                    <div className={style.contentWrap}>
                      <VerticalFlex gap={20}>
                        <FlexChild>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>썸네일</P>
                            </FlexChild>
                            <FlexChild>
                              <VerticalFlex gap={10} flexStart>
                                <FlexChild>
                                  <AdminInputImage
                                    ref={(el) => (inputs.current[6] = el)}
                                    name={"상품 라벨"}
                                    path={"/product"}
                                    labelWidth={0}
                                    cropWidth={600}
                                    cropHeight={600}
                                    value={
                                      data && data.product.thumbnail
                                        ? data.product.thumbnail
                                        : ""
                                    }
                                    maxSizeMb={1}
                                  />
                                </FlexChild>
                                <FlexChild borderBottom={"2px solid #e7e7e7"}>
                                  <Dummy height={10} />
                                </FlexChild>
                              </VerticalFlex>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                        <FlexChild>
                          <div className={style.line} />
                        </FlexChild>
                        <FlexChild height={"100%"}>
                          <HorizontalFlex gap={40}>
                            <FlexChild width={"15%"}>
                              <P>상세페이지</P>
                            </FlexChild>
                            <FlexChild height={"100%"}>
                              <div style={{ maxWidth: "1200px" }}>
                                <AdminQuillEditor
                                  ref={(el) => (inputs.current[7] = el)}
                                  name={"상세"}
                                  value={
                                    data && data.product.content
                                      ? data.product.content
                                      : ""
                                  }
                                  path={"product/" + "product.id"}
                                  preview={true}
                                />
                              </div>
                            </FlexChild>
                          </HorizontalFlex>
                        </FlexChild>
                      </VerticalFlex>
                    </div>
                  </FlexChild>
                </VerticalFlex>
              </div>
            </FlexChild>
            <FlexChild padding={15}>
              {isSpin && (
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <CSpinner style={{ position: "absolute", zIndex: 100 }} />
                </div>
              )}
              <Button text={"저장"} onClick={onSaveClick} />
            </FlexChild>
          </VerticalFlex>
        </Container>
      </div>
    </ModalBase>
  );
});

export default VariantStatusModal;
